import { render, staticRenderFns } from "./computed_loss_compositions_row1.vue?vue&type=template&id=7780c5fe&scoped=true"
import script from "./computed_loss_compositions_row1.vue?vue&type=script&lang=js"
export * from "./computed_loss_compositions_row1.vue?vue&type=script&lang=js"
import style0 from "./computed_loss_compositions_row1.vue?vue&type=style&index=0&id=7780c5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780c5fe",
  null
  
)

export default component.exports